import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Pagination,
  IconButton,
} from '@mui/material';
import { Edit, Delete, Visibility, PersonAdd, GroupAdd } from '@mui/icons-material';
import '../components/css/Users.css';
import colors from '../theme/Colors';
import Navbar from '../components/Navbar';
import { api } from '../helpers/apiRequest';
import CustomSelect from '../components/CustomSelect';
import { toast } from 'react-toastify';
import UserDetailsDialog from '../components/UserDetailsDialog';
import { pageAccessList } from '../helpers/pageAccessList';
const Users = () => {
  const [activeTab, setActiveTab] = useState('Admin');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone1: '',
    phone2: '',
    phone3: '',
    actual_password:'',
    company_name: '',
    address: '',
    // city: '',
    // country: '',
    fax: '',
    remarks: '',
    balance: 0,
    role: 'Merchant',
  });

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [assignCustomerDialogOpen, setAssignCustomerDialogOpen] = useState(false);
  const [currentMerchantId, setCurrentMerchantId] = useState(null);
  const [accessControl, setAccessControl] = useState({});
  const [userInfo, setUser] = useState('');
  const fetchUser=async()=>{
    let user = await localStorage.getItem('user');
    user = JSON.parse(user);
    setUser(user);
  }
  useEffect(()=>{
    fetchUser();
  },[]);
  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);
      setUser(user);
      setLoading(true);
      if (user) {
        const res = await api.get(`/users/get/routes?userId=${user?.id}`);
        const accessArray = res.data.message || [];

        // Map route permissions by route key
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        // Merge with full pageAccessList to ensure all routes are covered
        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        console.log("setAccessControl", accessControl);
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }
  const fetchUsers = async () => {
    setLoading(true);
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);
      setUser(user);
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', rowsPerPage);

      let response;
      if (searchTerm) {
        response = await api(`users/user-search/${searchTerm}?page=${page}&limit=${rowsPerPage}`);
      } else {
        const roleParam = activeTab.toLowerCase() === 'merchandiser' ? 'merchant' : activeTab.toLowerCase();
        response = await api(`users/users/role/${roleParam}?${queryParams.toString()}`);
      }

      if (response.status) {
        const data = await response.data.data;
        setUsers(data || []);
        setTotalPages(Math.ceil(response?.data?.total_count / rowsPerPage));
      } else {
        console.error('Failed to fetch users:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await api('users/users/role/customer');
      if (response.status) {
        setCustomers(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
    fetchUsers();
    setFormData((prev) => ({ ...prev, role: activeTab }));
    fetchCustomers();
  }, [activeTab, rowsPerPage, page]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setPage(1);
      fetchUsers();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchUsers();
  //     setFormData((prev) => ({ ...prev, role: activeTab }));
  //     fetchCustomers();
  //   }, 20000); 
  //   return () => clearInterval(interval);
  // }, []);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  const handleOpenEditForm = (user) => {
    setIsEditing(true);
    setFormData(user);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = isEditing
        ? `users/update/${formData._id}`
        : `users/admin/create-users`;

      const submitData = { ...formData };

      // Set the role based on the user type
      if (submitData.role === 'Employee') {
        submitData.role = 'employee'; // Pass role in lowercase for Employee
      } else if (submitData.role === 'Merchandiser') {
        submitData.role = 'merchant'; // Pass role as 'merchant' for Merchandiser
      }

      if (isEditing) {
        delete submitData._id;
        delete submitData.__v;
        if (!submitData.password) {
          delete submitData.password;
        }
      }

      const response = isEditing
        ? await api.put(url, submitData)
        : await api.post(url, submitData);

      if (response.status) {
        toast.success(isEditing ? 'User updated successfully!' : 'User added successfully!');
        setShowForm(false);
        fetchUsers();
        setFormData({
          name: '',
          email: '',
          password: '',
          phone1: '',
          phone2: '',
          phone3: '',
          company_name: '',
          address: '',
          city: '',
          country: '',
          fax: '',
          remarks: '',
          balance: 0,
          role: activeTab,
        });
        setIsEditing(false);
      } else {
        toast.error(response.data?.message || 'Failed to save user');
      }
    } catch (error) {
      console.error('Error saving user:', error);
      toast.error(error.message || 'Failed to save user. Please try again.');
    }
  };

  const handleOpenConfirmDeleteDialog = (id) => {
    setUserToDelete(id);
    setConfirmDeleteDialogOpen(true);
  };

  const handleDeleteUser = async () => {
    try {
      const response = await api.delete(`users/delete/${userToDelete}`);
      if (response.status) {
        toast.success('User deleted successfully!');
        fetchUsers();
      } else {
        throw new Error(response.data?.message || 'Failed to delete user');
      }
    } catch (error) {
      toast.error(error.message || 'Failed to delete user. Please try again.');
      console.error('Error deleting user:', error);
    } finally {
      setConfirmDeleteDialogOpen(false);
      setUserToDelete(null);
    }
  };

  const handleAssignCustomer = async () => {
    if (!selectedCustomer || !currentMerchantId) return;
    try {
      const payload = {
        merchantId: currentMerchantId,
        customerId: selectedCustomer,
      };
      const response = await api.post('users/assign', payload);
      if (response.status) {
        toast.success('Customer assigned successfully!');
        fetchUsers();
      } else {
        toast.error('Failed to assign customer');
      }
    } catch (error) {
      console.error('Error assigning customer:', error);
      toast.error(error?.response?.data?.message);
    } finally {
      setAssignCustomerDialogOpen(false);
      setSelectedCustomer(null);
      setCurrentMerchantId(null);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
      <Navbar title="Users" />
      <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <h2 style={{ textAlign: 'center', color: colors.primary, fontSize: 35 }}>Manage Users</h2>
        {
          (userInfo?.role === 'admin' || accessControl["manage-users"] === true) &&
          <Button
            variant="contained"
            style={{ margin: 8, borderRadius: 50, backgroundColor: colors.primary, fontSize: 15 }}
            onClick={() => setShowForm(true)}
          >
            +
          </Button>
        }
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap',
          padding: 2,
        }}
      >
        {['Admin', 'Merchandiser', 'Employee'].map((role) => (
          <Button
            key={role}
            sx={{
              backgroundColor: activeTab === role ? colors.primary : 'white',
              color: activeTab === role ? 'white' : colors.primary,
              borderWidth: 2,
              borderColor: colors.primary,
            }}
            variant={activeTab === role ? 'contained' : 'outlined'}
            onClick={() => setActiveTab(role)}
            style={{ margin: 8 }}
          >
            {role}
          </Button>
        ))}
      </Box>

      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <TextField
          label="Search users"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ width: 300 }}
          placeholder="Search by name"
        />
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>ID</TableCell> */}
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Email</TableCell>
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Phone</TableCell>
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Company</TableCell>
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Address</TableCell>
              {/* <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>City</TableCell> */}
              {/* <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Country</TableCell> */}
              <TableCell sx={{ backgroundColor: colors.primary, fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={9} style={{ textAlign: 'center' }}>
                  Loading...
                </TableCell>
              </TableRow>
            ) : users.length > 0 ? (
              users.map((user) => (
                <TableRow key={user._id}>
                  {/* <TableCell>{(user._id)?.slice(0, 10)}..</TableCell> */}
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.phone1}</TableCell>
                  <TableCell>{user.company_name}</TableCell>
                  <TableCell>{user.address}</TableCell>
                  {/* <TableCell>{user.city}</TableCell> */}
                  {/* <TableCell>{user.country}</TableCell> */}
                  <TableCell>
                    <IconButton
                      sx={{
                        backgroundColor: colors.primary,
                        color: 'white',
                        marginLeft: 1,
                      }}
                      onClick={() => handleViewUser(user)}
                      title="View"
                    >
                      <Visibility />
                    </IconButton>
                    {(activeTab !== 'Admin'&& (userInfo?.role === 'admin' || accessControl["manage-users"] === true)) && (
                      <>
                          <IconButton
                            sx={{
                              backgroundColor: colors.primary,
                              color: 'white',
                              marginLeft: 1,
                            }}
                            onClick={() => handleOpenEditForm(user)}
                            title="Edit"
                          >
                            <Edit />
                          </IconButton>
                        <IconButton
                          sx={{
                            backgroundColor: colors.primary,
                            color: 'white',
                            marginLeft: 1,
                          }}
                          onClick={() => handleOpenConfirmDeleteDialog(user._id)}
                          title="Delete"
                        >
                          <Delete />
                        </IconButton>
                        {activeTab === 'Merchandiser' && (
                          <>
                            <IconButton
                              sx={{
                                backgroundColor: colors.primary,
                                color: 'white',
                                marginLeft: 1,
                              }}
                              onClick={() => {
                                setSelectedCustomer(null);
                                setCurrentMerchantId(user._id);
                                setAssignCustomerDialogOpen(true);
                              }}
                              title="Assign Customer"
                            >
                              <PersonAdd />
                            </IconButton>
                          </>
                        )}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} style={{ textAlign: 'center' }}>
                  No users found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2, alignItems: 'center', gap: 2 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          showFirstButton
          showLastButton
        />
        <CustomSelect
          label="Rows per page"
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          options={[
            // { id: 5, name: '5' },
            // { id: 10, name: '10' },
            // { id: 25, name: '25' },
            // { id: 50, name: '50' },
            { id: 100, name: '100' },
            { id: 200, name: '200' },
            { id: 300, name: '300' },
            { id: 400, name: '400' },
            { id: 500, name: '500' },
          ]}
          sx={{ minWidth: 120 }}
        />
      </Box>


      <Dialog open={showForm} onClose={() => setShowForm(false)}>
        <DialogTitle style={{ color: colors.primary, textAlign: 'center', fontSize: 35 }}>
          {isEditing ? 'Edit User' : 'Add User'}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            {Object.keys(formData).map((key) => (
              (key !== '_id' && key !== '__v' && (!isEditing || key !== 'password')) && (
                <TextField
                  key={key}
                  label={key==="actual_password"?"Password":key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}
                  name={key}
                  value={formData[key]}
                  onChange={handleChange}
                  fullWidth
                  style={{ marginBottom: 16 }}
                  required={key === 'name' || key === 'email' || (key === 'password' && !isEditing)}
                  disabled={key === 'role' || (isEditing && key === 'email')}
                  type={key === 'password' ? 'password' : 'text'}
                />
              )
            ))}
            <DialogActions>
              <Button onClick={() => setShowForm(false)} color="secondary">
                Cancel
              </Button>
              <Button type="submit" color="primary">
                {isEditing ? 'Update' : 'Submit'}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      {selectedUser && (
        <UserDetailsDialog
          showUserModal={showUserModal}
          setShowUserModal={setShowUserModal}
          selectedUser={selectedUser}
        />
      )}
      {/* <Dialog open={showUserModal} onClose={() => setShowUserModal(false)} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            textAlign: 'center',
            color: colors.primary,
            fontSize: 24,
            fontWeight: 'bold',
            pb: 0,
          }}
        >
          User Details
        </DialogTitle>
        <DialogContent sx={{ px: 4, py: 2 }}>
          {selectedUser ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                mt: 2,
              }}
            >
              {[
                { label: 'Name', value: selectedUser.name },
                { label: 'Email', value: selectedUser.email },
                { label: 'Phone 1', value: selectedUser.phone1 },
                { label: 'Phone 2', value: selectedUser.phone2 },
                { label: 'Phone 3', value: selectedUser.phone3 },
                { label: 'Address', value: selectedUser.address },
                { label: 'City', value: selectedUser.city },
                { label: 'Country', value: selectedUser.country },
                { label: 'Company Name', value: selectedUser.company_name },
                { label: 'Fax', value: selectedUser.fax },
                { label: 'Remarks', value: selectedUser.remarks },
                { label: 'Balance', value: selectedUser.balance },
                { label: 'Role', value: selectedUser.role },
              ].map((field, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #e0e0e0',
                    pb: 1,
                    fontSize: '1rem',
                    color: 'text.primary',
                  }}
                >
                  <strong>{field.label}:</strong>
                  <span>{field.value}</span>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', mt: 3, color: 'text.secondary' }}>
              No user selected.
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', py: 2 }}>
          <Button
            onClick={() => setShowUserModal(false)}
            sx={{
              backgroundColor: colors.primary,
              color: 'white',
              borderColor: colors.primary,
              px: 4,
              borderRadius: '8px'
            }}
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog> */}

      <Dialog open={confirmDeleteDialogOpen} onClose={() => setConfirmDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this user?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteUser} color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={assignCustomerDialogOpen} onClose={() => setAssignCustomerDialogOpen(false)}>
        <DialogTitle>Assign Customer</DialogTitle>
        <DialogContent>
          <CustomSelect
            label="Select Customer"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
            options={customers.map(customer => ({ id: customer._id, name: customer.name }))}
            sx={{ minWidth: 300, mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAssignCustomerDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAssignCustomer} color="primary">
            Assign
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Users;
